import store from "../index";
import { connection } from "./hubConnection";

connection.on("UpdateClientDashboard", (clientDashboard) => {
  store.commit("clientModule/SET_CLIENT_DASHBOARD", clientDashboard);
});